<template>
  <div>
    <label class="label-control" v-if="label" v-bind="$attrs">{{ label }}</label>
    <div class="checkboxes-group" :style="`grid-gap: ${gap}; grid-template-columns: repeat(${customCols}, auto)`">
      <label class="app-checkbox" v-for="(option, index) in opt">
        <input
            type="checkbox"
            :disabled="option[disabledKey]"
            :checked="option[checkedKey || 'checked']"
            @change="change(option, index, $event)"
        />
        <span></span>
        <div v-if="renderLabel">{{renderLabel(option)}}</div>
        <div v-else>{{ option[labelKey || 'text'] }}</div>

      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'renderLabel',
    'options',
    'label',
    'direction',
    'cols',
    'gap',
    'mediaQuery',
    'labelKey',
    'checkedKey',
    'disabledKey',
  ],
  watch: {
    options: function (newVal) { // watch it

      this.opt = newVal
      this.$emit('input', this.opt)
    }
  },
  mounted() {
    if (this.$props.mediaQuery?.length) {
      this.mediaQueryListen()
      this.mediaQueryCalculate()
    }

    this.$emit('input', this.opt)
  },
  updated() {

    // this.$emit('input', this.opt)
  },
  unmounted() {
    if (this.$props.mediaQuery?.length) {
      this.mediaQueryRemoveListen()
    }
  },
  data() {
    return {
      opt: this.$props.options,
      customCols: this.$props?.cols
    }
  },
  methods: {
    mediaQueryListen() {
      window.addEventListener('resize', this.mediaQueryCalculate)
    },

    mediaQueryRemoveListen() {
      window.removeEventListener('resize', this.mediaQueryCalculate)
    },

    mediaQueryCalculate() {
      const mediaArray = this.$props.mediaQuery.sort((a, b) => a.media - b.media)

      mediaArray.forEach((screen) => {
        if (window.innerWidth > screen.media) {
          this.customCols = screen.cols
        }
      })
    },

    change(option, index, event) {
      const possibleKey = this.checkedKey || 'checked'

      this.opt = this.opt.map((item, i) => {
        if (index === i) {
          return {
            ...item,
            [possibleKey]: !item[possibleKey]
          }
        }

        return {
          ...item,
          [possibleKey]: !!item[possibleKey]
        }
      })

      // 'method' / 'checkbox-group' / current checkbox
      this.$emit('input', this.opt, this.opt[index], event)
    }
  }
}
</script>

<style lang="scss" scoped>
.checkboxes-group {
  display: grid;
  justify-content: flex-start;
  grid-column-gap: 20px;
  width: 100%;
}
</style>
